
/**
 * Module dependencies.
 */

import { availableFilterEffects } from 'src/core/collections-config/effects';
import { getProductEffectImage } from 'src/core/utils/images';
import { useFiltersList } from 'src/context/filters-list/context';
import { useTranslate } from 'src/core/utils/translator';
import FilterDisclosure from 'src/components/filters/filter-disclosure';
import FilterItem from 'src/components/filters/filter-item';
import FilterItemLabel from 'src/components/filters/filter-item-label';
import React, { ReactElement, useMemo } from 'react';
import keys from 'lodash/keys';
import sortBy from 'lodash/sortBy';
import split from 'lodash/split';

/**
 * `Props` type.
 */

type Props = {
  filterName: string
};

/**
 * `EffectFilter` component.
 */

const EffectFilter = ({ filterName }: Props): ReactElement => {
  const { translate } = useTranslate();
  const { filters } = useFiltersList();
  const hasFilter = keys(filters).includes(filterName);
  const selectedFilters = hasFilter ? split(filters[filterName], ',').map(effect => {
    return translate(`collections:effects.${effect}`);
  }) : [];

  const orderedEffects = useMemo(() => {
    return sortBy(availableFilterEffects, effect => {
      return translate(`collections:effects.${effect}`);
    });
  }, [translate]);

  return (
    <FilterDisclosure
      name={filterName}
      selectedFilters={selectedFilters}
      title={translate('common:labels.effect')}
    >
      {orderedEffects.map((effect: string, index: number) => (
        <FilterItem
          key={index}
          label={(
            <FilterItemLabel
              title={translate(`collections:effects.${effect}`)}
              type={'image'}
              value={getProductEffectImage(effect)}
            />
          )}
          name={filterName}
          value={effect}
        />
      ))}
    </FilterDisclosure>
  );
};

/**
 * Export `EffectFilter` component.
 */

export default EffectFilter;
